/**
 * bar-button.js
 */

import React from 'react';
import {
  IconButton
} from '@mui/material';


export default function BarButton(props) {
  return (
    <IconButton
      size="large"
      edge={props.edge}
      color={props.color || 'inherit'}
      onClick={props.onClick}
      disabled={props.disabled}
      aria-label={props['aria-label']}
      aria-controls={props['aria-controls']}
      aria-haspopup={props['aria-haspopup']}
      data-testid={props['data-testid']}
      sx={{
        p: props.wide ? '6px 8px' : '9px 10px',
        my: 0,
        mx: 0.5,
        mr: props.edge === 'end' ? -1.5 : 0.5,
        borderRadius: '8px',
        '&:hover': {
          backgroundColor: 'rgba(255,255,255,0.12)'
        },
        '&.Mui-disabled': {
          color: 'text.disabled'
        },
      }}
    >
      {props.children}
    </IconButton>
  );
}